module.exports = __webpack_public_path__ + "static/media/pformbgright.d2c23418.webp";